package com.islamicmedia.site.components

import androidx.compose.runtime.Composable
import com.islamicmedia.site.theme.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

/** One row of [MenuScreen]. */
class MenuItem(
    val label: String,
    /** Shown INSTEAD of the plain label (e.g. the animated KIDZONE logo). */
    val content: (@Composable () -> Unit)? = null,
    val onClick: () -> Unit
)

/**
 * The avatar menu as a card screen (Index's ActiveView.MENU), replacing the old dropdown. Same
 * destinations in the same order, as centred words in the open with hairlines between them — no
 * title, no row boxes. The top padding clears the card's ✕. Rows take the page's `.menu-item`
 * hover. Mirrors composeApp/.../components/MenuScreen.kt.
 */
@Composable
fun MenuScreen(items: List<MenuItem>) {
    Div(attrs = {
        style {
            padding(56.px, 28.px)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            property("box-sizing", "border-box")
        }
    }) {
        items.forEachIndexed { i, item ->
            if (i > 0) Div(attrs = { style { height(1.px); backgroundColor(Gray200) } })
            Div(attrs = {
                classes("menu-item")
                onClick { item.onClick() }
                style {
                    // Mobile: a row with custom content (the KIDZONE logo) is 14 above and below, plain words are 18.
                    padding((if (item.content != null) 14 else 18).px, 0.px)
                    property("text-align", "center")
                    fontSize(16.px); fontWeight(500); color(Gray700)
                    cursor("pointer")
                    borderRadius(8.px)
                }
            }) { if (item.content != null) item.content.invoke() else Text(item.label) }
        }
    }
}
